<template>
  <div>
    <div style="display: flex; align-items: center; height: 68px; background-color: #f4f4f5">
        <img :src="$baseUrl+ 'sekulogo2.png'"
           @click="$router.push('/')"
           style="width: 100px; height: 60px">
      <!-- <img :src="$baseUrl+ 'favicon.png'"
           @click="$router.push('/')"
           style="margin-left: 20px; margin-right: 16px; cursor: pointer; width: 50px; height: 50px"> -->
      <horiz-menu style="flex-shrink: 0" :menuList="menuList"></horiz-menu>
      <!--<search-popover>-->
      <!--<el-button v-show="isKanban"-->
      <!--slot="reference"-->
      <!--type="text"-->
      <!--icon="el-icon-search"-->
      <!--style="color: black; font-size: 14px; font-weight: 500; border-radius: 0;"-->
      <!--class="menu-item hover-effect search-button">搜索-->
      <!--</el-button>-->
      <!--</search-popover>-->
      <!--<el-button v-ADD_WORK v-show="isKanban" @click="addWork" type="text" class="menu-item hover-effect search-button">-->
      <!--新增工单-->
      <!--</el-button>-->
      <div style="flex-grow: 1"></div><!-- flex 占位 -->
      <div style="flex-grow: 1"></div><!-- flex 占位 -->
      <div v-loading="!myOrgan" style="margin-right: 16px; flex-shrink: 0; color: #1890ff; font-weight: 500">
        {{myOrgan ? myOrgan.name : ''}}
      </div>
      <!--<shop-select v-group style="margin-right: 16px"></shop-select>-->
      <!--todo <screen-full id="screenFull" class="menu-item hover-effect"/>-->
      <user-info-drop-down class="menu-item hover-effect"
                           style="margin-right: 20px; flex-shrink: 0"></user-info-drop-down>
    </div>
    <!--<breadcrumb style="width: 90%; margin: auto; display: block;" v-show="$route.name !== kanban"/>-->
    <el-page-header style="width: 90%; height: 50px; line-height: 50px; color: #1090ff; margin: auto;"
                    v-show="showPageHeader" @back="$router.back()">
      <template #content>
        <div style="color: #1090ff; font-size: 15px">{{$route.matched[1].meta.title}}</div>
      </template>
    </el-page-header>
  </div>
</template>

<script>
  import UserInfoDropDown from '@/layout/TopBar/UserInfoDropDown'
  import HorizMenu from '@/layout/menu/index'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import { myInfo } from '@/utils/request'

  export default {
    name: 'TopBar',
    mixins: [shareDataMixin],
    components: {
      HorizMenu,
      UserInfoDropDown
    },
    data () {
        return {
            menuList: []
        }
    },
    created () {
        myInfo().then(response => {
            this.menuList = response.data.user.permissions
        })
    },
    computed: {
      showPageHeader () {
        if (!this.$route.meta) return true
        return !this.$route.meta.hidePageHeader
      }
    }
  }
</script>

<style lang="scss" scoped>
  .menu-item {
    height: 68px;
    line-height: 68px;
    padding: 0 8px;
    font-size: 14px;
    color: black;
    border-radius: 0;

    &.hover-effect {
      cursor: pointer;
      transition: background .3s;

      &:hover {
        background: lightgray;
        color: black;
      }
    }
  }
</style>
